import ReactiveWidget from "lib/reactiveWidget";

import $              from "jquery"
import select2        from "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"

import GeocompletedAddress from 'widgets/geocompletedAddress'

class ExternalProjectSearchWidget extends ReactiveWidget {
  bind() {
    this.projectName = $(this.root.find('#external-projects-search'))
    bindProjectSearch.call(this)
    bindAddressLocator.call(this);
  }

  render() {

  }
}

const bindAddressLocator = function() {
  let elem = this.root.find('form')
  new GeocompletedAddress({
    root: elem,
    options: {
      types: ['address'],
      country: 'AU'
    }
  });
};

var bindProjectSearch = function() {
  this.projectName.select2({
    placeholder: 'Search for a project',
    minimumInputLength: 1,
    allowClear: true,
    tags: true,
    theme: 'bootstrap',
    ajax: {
      url: `/external/account/${gon.account_token}/projects`,
      dataType: 'json',
      delay: 250,
      data: (params) => {
        return { by_keyword: params.term }
      },
      processResults: (data) => {
        return {
          results: data.results
        }
      },
      cache: true
    }
  });

  this.projectName.on('select2:select', (e) => {
    const projectId = e.target.value
    window.location = `/external/account/${gon.account_token}/projects/${projectId}`
  });
}

export default ExternalProjectSearchWidget
